module.exports = __webpack_public_path__ + "static/img/minicons1.afabb94a.png";